/*
  File: src/components/home/PosterGrid.jsx
  Purpose: Futuristic Netflix-style poster grid for TV and Movies.
  Props:
    - items?: Array<{ id?: string|number, title: string, poster: string, tag?: string, meta?: string }>
    - onSelect?: (item) => void
    - count?: number (fallback placeholders if items not provided)
*/
import React from 'react';

/**
 * PosterGrid
 * Renders a responsive grid of media posters with neon/glass styling.
 */
function PosterGrid({ items, onSelect, count = 12 }) {
  const data = Array.isArray(items) && items.length
    ? items
    : Array.from({ length: count }).map((_, i) => ({
        id: `ph-${i}`,
        title: `Title ${i + 1}`,
        poster: '',
        tag: 'New',
        meta: 'HD'
      }));

  return (
    <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
      {data.map((item, idx) => (
        <button
          key={item.id ?? idx}
          data-item-id={item.id}
          onClick={() => onSelect && onSelect(item)}
          className="group relative bg-white/5 border border-white/10 rounded-2xl p-4 hover:bg-white/10 hover:border-white/20 transition-all duration-300 cursor-pointer hover:transform hover:-translate-y-2 focus:outline-none"
        >
          <div className="aspect-[3/4] bg-gradient-to-br from-slate-600 to-slate-700 rounded-xl mb-4 overflow-hidden relative">
            {item.poster ? (
              <img
                src={item.poster}
                alt={item.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                onError={(e) => { e.currentTarget.style.display = 'none'; }}
              />
            ) : (
              <div className="absolute inset-0 bg-white/10" />
            )}
          </div>
          <div>
            <div className="text-white font-semibold mb-1 truncate">{item.title}</div>
            {item.meta && <div className="text-slate-400 text-sm truncate">{item.meta}</div>}
          </div>
        </button>
      ))}
    </div>
  );
}

export default PosterGrid;


